import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../gd-components/base-component/base-component";

import TreeCompanyView from './components/tree-company-view.jsx';
import TreeProjectView from './components/tree-project-view.jsx';
import VScroll from '../../gd-components/scrolling/custom-v-scroll/v-scroll.tsx';

export default class GDTreeMultiselect extends BaseComponent {
    static propTypes = {
        source: PropTypes.object.isRequired,

        companies: PropTypes.array,
        expanded: PropTypes.shape({
            companies: PropTypes.array,
            projects: PropTypes.array
        }),
        values: PropTypes.shape({
            companies: PropTypes.array,
            projects: PropTypes.array
        }),
        filterProjects: PropTypes.arrayOf(PropTypes.shape({
            counter: PropTypes.number,
            item: PropTypes.object
        })),
        ignoredParentProjects: PropTypes.array,

        unselectLabel: PropTypes.string,

        companiesSelectable: PropTypes.bool,
        inheritedChildrenSelection: PropTypes.bool,
        multiselectDifferLabelAndCheckboxClick: PropTypes.bool,
        singleCompanyVisible: PropTypes.bool,
        showEmptyCompanies: PropTypes.bool,
        showOnlyFilterProjects: PropTypes.bool,
        showGhostParents: PropTypes.bool,
        showCompanyIcon: PropTypes.bool,
        showProjectIcon: PropTypes.bool,
        showProjectIconColorized: PropTypes.bool,
        noCollapseExpand: PropTypes.bool,
        scrollContentStyle: PropTypes.object,
        autoExpandParentsOfSelected: PropTypes.bool,
        updateExpandedOnReceiveProps: PropTypes.bool,
        noScroll: PropTypes.bool,
        highlightOnHover: PropTypes.bool,
        multiselectCheckboxType: PropTypes.oneOf(['default','full-colored','filled']),
        multiselectCheckboxSize: PropTypes.oneOf(['normal','normal-14','small']),

        onChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        expanded: {},
        ignoredParentProjects: [],
        companiesSelectable: true,
        inheritedChildrenSelection: true,
        multiselectDifferLabelAndCheckboxClick: false,
        singleCompanyVisible: true,
        showEmptyCompanies: true,
        showGhostParents: true,
        autoExpandParentsOfSelected: true,
        updateExpandedOnReceiveProps: true,
        noScroll: false,
        multiselectCheckboxType: 'default',
        multiselectCheckboxSize: 'normal-14',
    };

    constructor(props, context) {
        super(props, context);
        const { values } = props;

        const initialValues = {
            projects: values && values.projects ? values.projects : [],
            companies: values && values.companies ? values.companies : []
        };

        this.state = {
            expanded: this.initialItemsExpand(props),
            values: initialValues,
            projectsToShow: this.getProjectsToShow(props)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { values, updateExpandedOnReceiveProps } = nextProps;
        const initialValues = {
            projects: values && values.projects ? values.projects : [],
            companies: values && values.companies ? values.companies : []
        };

        this.setState({
            expanded: updateExpandedOnReceiveProps ? this.initialItemsExpand(nextProps) : this.state.expanded,
            values: initialValues,
            projectsToShow: this.getProjectsToShow(nextProps)
        });
    }

    getProjectsToShow = (props) => {
        let projectsToShow = null;
        if (props.showOnlyFilterProjects) {
            projectsToShow = [];
            props.filterProjects && props.filterProjects.map(fp=>{
                const project = props.source.getProject(fp.item.id);
                const parentsIds = props.showGhostParents ? props.source.findProjectParents(project).map(p=>p.id) : [];
                projectsToShow = projectsToShow.concat([fp.item.id]).concat(parentsIds);
            });

            projectsToShow = _.uniq(projectsToShow);
        }

        return projectsToShow;
    };

    initialItemsExpand = (props) => {
        let toExpand = [];
        toExpand = toExpand.concat(props.expanded.companies ? props.expanded.companies.map(id=>"c_"+id) : []);
        toExpand = toExpand.concat(props.expanded.projects ? props.expanded.projects.map(id=>"p_"+id) : []);

        if (props.autoExpandParentsOfSelected && props.values){
            props.values.projects.map(pId=>{
                const project = props.source.getProject(pId);
                if (project) {
                    toExpand = toExpand.concat(props.source.findProjectParents(project).map(p=>"p_"+p.id));
                    toExpand.unshift("c_"+project.companyId);
                }
            });

            toExpand = _.uniq(toExpand);
        }

        return toExpand;
    };

    onToggleExpand = (id) => {
        const oldIsExpanded = this.state.expanded.includes(id);
        const newIsExpanded = !oldIsExpanded;

        const newExpanded = this.state.expanded.slice(0);

        if (newIsExpanded)  newExpanded.push(id);
        else                newExpanded.remove(id);

        this.setState({expanded: newExpanded});
    };

    _findChildrenOfProjects(projects) {
        let childrenToLeave = new Set();
        _.map(projects, id=>{
            const children = this.props.source.findProjectChildren(id).map(c=>c.id);
            childrenToLeave = new Set([...childrenToLeave, ...children]);
        })
        return [...childrenToLeave];
    }

    onClickUnselect = () => {
        this.setState({
            values: {
                projects: [],
                companies: []
            }
        }, ()=>{this.props.onChange(this.state.values)});
    };

    onProjectClick = (project, isCheckboxClick) => {
        let newValue;

        if (this.state.values) {
            const { projects, companies } = this.state.values;

            let newProjects = projects.slice();

            if (project.id){
                const index = newProjects.indexOf(project.id);
                if (index === -1) newProjects.push(project.id);
                else newProjects.splice(index,1);
            }

            if (this.props.inheritedChildrenSelection) {
                //check if clicked project is already have inherited selection (i.e one of it's parents selected)
                const clickedProjectParents = this.props.source.findProjectParents(this.props.source.getProject(project.id)).map(p=>p.id);
                const alreadySelectedParentsOfClickedProject = _.intersection(newProjects, clickedProjectParents);
                if (alreadySelectedParentsOfClickedProject.length > 0 || companies.includes(project.companyId)) {
                    if (this.props.multiselectDifferLabelAndCheckboxClick) {
                        //if checkbox click just remove clicked project from selection and add other
                        if (isCheckboxClick) {
                            const childrenToLeave = this._findChildrenOfProjects(alreadySelectedParentsOfClickedProject);
                            newProjects = _.union(newProjects, childrenToLeave);

                            _.remove(newProjects, id=>alreadySelectedParentsOfClickedProject.includes(id));
                            if (newProjects.includes(project.id)) _.remove(newProjects, id=>id === project.id);

                        } else {
                            /*//otherwise select clicked project and unselect its parent
                            const childrenToRemove = this._findChildrenOfProjects(alreadySelectedParentsOfClickedProject);

                            _.remove(newProjects, id=>childrenToRemove.includes(id) || alreadySelectedParentsOfClickedProject.includes(id));
                            if (!newProjects.includes(project.id)) newProjects.push(project.id);*/

                            //otherwise select clicked project and unselect all the rest
                            newProjects = [project.id];
                        }

                    } else {
                        //remove clicked project and leave already selected parent
                        newProjects = projects.slice();
                    }
                } else if (this.props.multiselectDifferLabelAndCheckboxClick && !isCheckboxClick) {
                    //select clicked project and unselect all the rest
                    newProjects = [project.id];
                }

                //remove all children from resulting projects array, they'll have inherited selection
                const clickedProjectChildren = this.props.source.findProjectChildren(project.id).map(c=>c.id);
                const alreadySelectedChildrenOfClickedProject = _.intersection(newProjects, clickedProjectChildren);
                _.remove(newProjects, id=>alreadySelectedChildrenOfClickedProject.includes(id));
            }

            newValue = {
                projects: newProjects,
                companies: companies
            };

            this.setState({values: newValue}, ()=>{this.props.onChange(newValue)});
        }
    };

    onCompanyClick = (companyId) => {
        const { source } = this.props;
        const { values } = this.state;

        if (this.props.companiesSelectable) {
            const { projects, companies } = values;

            const newCompanies = companies.slice();
            let newProjects = projects.slice();

            const index = newCompanies.indexOf(companyId);
            if (index === -1) newCompanies.push(companyId);
            else newCompanies.splice(index,1);

            if (this.props.inheritedChildrenSelection) {
                const selectedCompanyChildren = source.findCompanyChildren(companyId).map(c=>c.id);

                const selectedCompanyChildrenSelected = _.intersection(newProjects, selectedCompanyChildren);
                _.remove(newProjects, id=>selectedCompanyChildrenSelected.indexOf(id) !== -1);
            }

            const newValue = {
                projects: newProjects,
                companies: newCompanies
            };

            this.setState({values: newValue}, ()=>{this.props.onChange(newValue)});

        } else {
            if (!this.props.noCollapseExpand)
                this.onToggleExpand("c_"+companyId);
        }
    };

    renderCompanyTree = (model) => {
        let selectedCompanies = this.state.values.companies;
        let selectedProjects = this.state.values.projects;

        const renderTree = (level, parent, inheritedSelection)=>{
            let items = [];
            const isSelectedInherited = this.props.inheritedChildrenSelection ? inheritedSelection : false;

            if (parent.projects) items = parent.projects;
            else items = parent.children ? parent.children : [];

            items.map((i)=>{
                const p = i.project;
                const filteredOut = this.state.projectsToShow && !this.state.projectsToShow.includes(p.id);

                if (!filteredOut) {

                    //do not render ignored parent and render its children shifted one level up
                    if (!this.props.ignoredParentProjects.includes(p.id)) {
                        const filterItem = this.props.filterProjects ? this.props.filterProjects.find(fp=>fp.item.id === p.id) : null;
                        const expandable = !!i.children.length > 0 &&
                            (!this.state.projectsToShow || _.intersection(i.children.map(c=>c.project.id), this.state.projectsToShow).length > 0);

                        const isExpanded = this.state.expanded.includes("p_"+p.id);
                        const isSelected = selectedProjects.includes(p.id);
                        const selectable = !filterItem || !filterItem.notSelectable;

                        res.push(<TreeProjectView key={p.id}
                                                  project={p}
                                                  counter={filterItem ? filterItem.counter : null}
                                                  selectable={selectable}
                                                  expandable={expandable}
                                                  isSelected={isSelected}
                                                  isExpanded={isExpanded}
                                                  isSelectInherited={isSelectedInherited}
                                                  level={level}
                                                  multiselect={true}
                                                  multiselectCheckboxType={this.props.multiselectCheckboxType}
                                                  multiselectCheckboxSize={this.props.multiselectCheckboxSize}
                                                  showProjectIcon={this.props.showProjectIcon}
                                                  showProjectIconColorized={this.props.showProjectIconColorized}
                                                  noCollapseExpand={this.props.noCollapseExpand}
                                                  onClick={this.onProjectClick}
                                                  onToggleExpand={this.onToggleExpand}/>);

                        if (expandable && isExpanded) renderTree(level+1,i, isSelected || isSelectedInherited);
                    } else {
                        renderTree(level,i, isSelectedInherited);
                    }

                } else if (!this.props.showGhostParents) {
                    if (i.children.length > 0) renderTree(level,i);
                }
            });
        };

        const company = model.company;
        const isExpanded = this.state.expanded.includes("c_"+company.id);
        const isSelected = company.id && selectedCompanies.indexOf(company.id) !== -1;

        const res = [];

        const showCompany = this.props.companies.length !== 1 || this.props.singleCompanyVisible;
        if (showCompany) {
            const treeCompanyViewClasses = Classes({
                "not-selectable": !this.props.companiesSelectable
            });

            const renderCompany = this.props.showEmptyCompanies ||
                (this.props.filterProjects ? !!this.props.filterProjects.find(fp=>fp.item.companyId === company.id) : model.projects.length > 0);

            const expandable = model.projects.length > 0 &&
                (!this.state.projectsToShow || _.intersection(model.projects.map(c=>c.project.id), this.state.projectsToShow).length > 0);

            if (renderCompany) {
                res.push(
                    <TreeCompanyView key={"company_" + company.id}
                                     className={treeCompanyViewClasses}
                                     company={company}
                                     selectable={this.props.companiesSelectable}
                                     isSelected={isSelected}
                                     isExpanded={isExpanded}
                                     showCompanyIcon={this.props.showCompanyIcon}
                                     noCollapseExpand={this.props.noCollapseExpand}
                                     multiselect={true}
                                     multiselectCheckboxType={this.props.multiselectCheckboxType}
                                     multiselectCheckboxSize={this.props.multiselectCheckboxSize}
                                     onClick={this.onCompanyClick}
                                     onToggleExpand={this.onToggleExpand}/>
                );

                if (expandable && isExpanded)   renderTree(1, model, isSelected);
            }
        } else {
            if (model.projects)                 renderTree(0, model, isSelected);
        }

        return res;
    };

    renderUnselect = () => {
        const unselectLabelClasses = Classes("gd-tree-item-unselect", "is-multiselect",{
            'gd-tree-item-selected': !this.state.values || (this.state.values.companies.length === 0 && this.state.values.projects.length === 0)
        });

        return this.props.unselectLabel ?
            <div className={unselectLabelClasses} onClick={this.onClickUnselect}>
                <div className="gd-tree-item-name">{this.props.unselectLabel}</div>
            </div>
            : null
    };

    renderNoScroll = () => {
        const { companies, scrollContentStyle, highlightOnHover, className } = this.props;
        const classes = Classes(className, 'gd-tree', "is-multiselect", {
            "highlight-on-hover": highlightOnHover
        });

        return (
            <div className={classes} style={scrollContentStyle}>
                {this.renderUnselect()}
                {companies.map(m=>this.renderCompanyTree(m))}
            </div>
        );
    };

    renderDefault = () => {
        const { companies, scrollContentStyle, highlightOnHover, className } = this.props;
        const classes = Classes(className, 'gd-tree', "is-multiselect", {
            "highlight-on-hover": highlightOnHover
        });

        return (
            <VScroll className={classes} containerStyle={scrollContentStyle}>
                {this.renderUnselect()}
                {companies.map(m=>this.renderCompanyTree(m))}
            </VScroll>
        );
    };

    render() {
        return this.props.noScroll ? this.renderNoScroll() : this.renderDefault();
    }
}